import { useQuery } from "@tanstack/react-query";
import { workQueueService } from "@/core/api/services";
import { workbenchKeys } from "@/core/api/queryKeys";

export interface WorkItemFilters {
  statuses?: string[];
  types?: string[];
  tags?: Record<string, string>;
  claimedBy?: string;
  sortBy?: string;
  sortDesc?: boolean;
  pageSize?: number;
  pageToken?: string;
}

export function useWorkItems(filters: WorkItemFilters = {}) {
  const query = useQuery({
    queryKey: workbenchKeys.workItems.list(filters as Record<string, unknown>),
    queryFn: async () => {
      const response = await workQueueService.listWorkItems({
        statuses: filters.statuses ?? [],
        types: filters.types ?? [],
        tags: filters.tags ?? {},
        claimedBy: filters.claimedBy ?? "",
        sortBy: filters.sortBy ?? "",
        sortDesc: filters.sortDesc ?? false,
        pageSize: filters.pageSize ?? 50,
        pageToken: filters.pageToken ?? "",
      });
      return {
        items: response.items ?? [],
        nextPageToken: response.nextPageToken ?? "",
        totalCount: response.totalCount ?? 0,
      };
    },
    staleTime: 10 * 1000,
  });

  return {
    items: query.data?.items ?? [],
    totalCount: query.data?.totalCount ?? 0,
    nextPageToken: query.data?.nextPageToken ?? "",
    loading: query.isLoading,
    error: query.error?.message ?? null,
    refetch: query.refetch,
  };
}
